import Const from '../Const'
import {observable, action} from 'mobx'
import DataTools from '../toolsClass/DataTools'

class UIState {
  meterTimer;
  constructor() {
    const dataTools = DataTools.createDataToolsClass()
    const index = dataTools.randomCount(Const.randomShowKey.length)
    this.showKey = Const.randomShowKey[index]
  }
  @observable inputA = Const.text.get("input")
  @observable showKey
  @observable meterValue = 0
  @observable loadingStyle = Const.styleKey.hide
  @observable toastStyle = Const.styleKey.toastPrimary
  @observable inputButtonStyle = Const.styleKey.inputButtonPrimary
  @action setInputA = (value)=>{
    this.inputA = value
  }
  @action setloadingStyle = (style)=>{
    if(style !== this.loadingStyle)
      this.loadingStyle = style
  }
  @action meterValuePlusCount = (count)=>{
    this.meterValue += count
  }
  @action ChangeMeterValue = (count)=>{
    this.meterValue = count
  }
  @action beDoingUI = ()=>{
    this.ChangeMeterValue(0)
    if(this.meterTimer)
      clearInterval(this.meterTimer)
    this.loadingStyle = null
    this.showKey = Const.showKey.xzing
    this.meterTimer = setInterval(()=>{
      this.meterValuePlusCount(3)
      if(this.meterValue >= 81){
        clearInterval(this.meterTimer)
        this.meterTimer = null
      }
    },10)
    this.toastStyle = Const.styleKey.toastPrimary
    this.inputButtonStyle = Const.styleKey.inputButtonPrimary
  }
  @action beNotUI = ()=>{
    if(this.meterTimer)
      clearInterval(this.meterTimer)
    this.loadingStyle = Const.styleKey.hide
    this.showKey = Const.showKey.xzNot
    this.ChangeMeterValue(0)
    this.toastStyle = Const.styleKey.toastPrimary
    this.inputButtonStyle = Const.styleKey.inputButtonPrimary
  }
  @action beSuccessUI = ()=>{
    if(this.meterTimer)
      clearInterval(this.meterTimer)
    this.loadingStyle = Const.styleKey.hide
    this.showKey = Const.showKey.xzSuccess
    this.meterTimer = setInterval(()=>{
      this.meterValuePlusCount(3)
      if(this.meterValue >= 100){
        clearInterval(this.meterTimer)
        this.meterTimer = null
      }
    },Math.round(200*3/(100-this.meterValue)))
    this.toastStyle = Const.styleKey.toastSuccess
    this.inputButtonStyle = Const.styleKey.inputButtonSuccess
  }
  @action beWarningUI = ()=>{
    if(this.meterTimer)
      clearInterval(this.meterTimer)
    this.loadingStyle = Const.styleKey.hide
    this.showKey = Const.showKey.xzWarning
    this.meterTimer = setInterval(()=>{
      this.meterValuePlusCount(this.meterValue <= 60 ? 3 : -3)
      if(this.meterValue <= 60 ? (this.meterValue >= 60) : (this.meterValue <= 60)){
        clearInterval(this.meterTimer)
        this.meterTimer = null
      }
    },Math.round(200*3/Math.abs((60-this.meterValue))))
    this.toastStyle = Const.styleKey.toastWarning
    this.inputButtonStyle = Const.styleKey.inputButtonWarning
  }
  @action beErrorUI = ()=>{
    if(this.meterTimer)
      clearInterval(this.meterTimer)
    this.loadingStyle = Const.styleKey.hide
    this.showKey = Const.showKey.xzError
    this.meterTimer = setInterval(()=>{
      this.meterValuePlusCount(this.meterValue <= 30 ? 3 : -3)
      if(this.meterValue <= 30 ? (this.meterValue >= 30) : (this.meterValue <= 30)){
        clearInterval(this.meterTimer)
        this.meterTimer = null
      }
    },Math.round(200*3/Math.abs((30-this.meterValue))))
    this.toastStyle = Const.styleKey.toastError
    this.inputButtonStyle = Const.styleKey.inputButtonError
  }






}
export const uiState = new UIState()



// WEBPACK FOOTER //
// ./src/stateClass/UIState.js